import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";
import { pushIf } from "./utils/pushIf";

const reduceRemoveMilestoneState = createStateReducer(initialState, {
  [events.removeMilestoneSucceeded]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "removeMilestone",
        flags: ["success"],
        args: { success: "true" },
      },
      state.queue,
    ),
  }),
  [events.removeMilestoneFailed]: (state, { error }) => ({
    ...state,
    queue: updateNotification(
      {
        key: "removeMilestone",
        flags: pushIf({
          ...error,
          failure: !Object.values(error).includes(true),
        }),
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
});

export { reduceRemoveMilestoneState };
